export default "__VITE_ASSET__BRl2zMHZ__"